import moment from 'moment/min/moment-with-locales'

const formatter = (value, type, locale = 'en-GB') => {
  if (type === 'percentage' || type === 'number' || type === 'KMB') {
    value = value || 0

    if (Number.isNaN(value)) {
      value = 0
    }
  }

  if (type === 'date') {
    const valueTime = moment(new Date(value), 'YYYYMMDD HH:mm:ss')
    const differenceInSeconds = moment().diff(valueTime, 'seconds')

    // 7 days = 604800 seconds
    if (differenceInSeconds > 604800) {
      return valueTime.locale('en').format('DD MMM YYYY')
    }

    let result = (locale === 'fr') ?
      moment(new Date(value), 'YYYYMMDD').locale('fr').fromNow() :
      moment(new Date(value), 'YYYYMMDD').locale('en').fromNow()
    if (result === 'a few seconds ago') {
      result = 'Just now'
    }

    return result
  }

  if (type === 'percentage') {
    return `${parseFloat((value * 100).toFixed(1))}%`
  }

  if (type === 'number' && locale) {
    return parseFloat(value).toLocaleString(locale)
  }

  if (type === 'KMB') {
    const oneThousand = 1000
    const oneMillion = 1000 * 1000
    const oneBillion = 1000 * 1000 * 1000

    if (value >= oneBillion) {
      return `${parseFloat((value / oneBillion).toFixed(1)).toLocaleString(locale)}B`
    }

    if (value >= oneMillion) {
      return `${parseFloat((value / oneMillion).toFixed(1)).toLocaleString(locale)}M`
    }

    if (value >= oneThousand) {
      return `${parseFloat((value / oneThousand).toFixed(1)).toLocaleString(locale)}k`
    }

    return value
  }

  return value
}

const displayer = (options = {}) => {
  let { disappearedAt } = options
  const { showingOnDays } = options

  if (disappearedAt) {
    disappearedAt = moment(disappearedAt)
    return moment().isBefore(disappearedAt)
  }

  if (showingOnDays && showingOnDays.length) {
    const today = moment().format('dddd')
    return showingOnDays.some((day) => today === moment.weekdays(day))
  }
  return false
}

export default {
  displayer,
  formatter,
}
